module.exports = __webpack_public_path__ + "img/construction.29775979.jpg";